/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../app/common/pipes/firstKeyPipe';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '../../../../../app/components/common/inline-input/inline-input.component';
import * as i5 from '../../../../../app/common/directives/trimValueAccessor';
const styles_InlineInputComponent:any[] = ([] as any[]);
export const RenderType_InlineInputComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_InlineInputComponent,data:{}});
function View_InlineInputComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.open()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' ',' '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','material-icons']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['mode_edit'])),(_l()(),i0.ɵted((null as any),
          [' ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.model;
    _ck(_v,1,0,currVal_0);
  });
}
function View_InlineInputComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['HS code should be: XXXX.XX.XX.XX or XXXX.XX.XXXX']))],
      (null as any),(null as any));
}
export function View_InlineInputComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i1.FirstKeyPipe,([] as any[])),i0.ɵqud(402653184,1,{inputReference:0}),
      i0.ɵqud(402653184,2,{modelRef:0}),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_InlineInputComponent_1)),i0.ɵdid(16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          29,'div',([] as any[]),[[8,'hidden',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),26,'form',[['novalidate','']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'submit'],
              [(null as any),'reset']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,10).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,10).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i3.ɵbf,([] as any[]),
          (null as any),(null as any)),i0.ɵdid(16384,[['inputForm',4]],0,i3.NgForm,
          [[8,(null as any)],[8,(null as any)]],(null as any),(null as any)),i0.ɵprd(2048,
          (null as any),i3.ControlContainer,(null as any),[i3.NgForm]),i0.ɵdid(16384,
          (null as any),0,i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),19,'div',[['class','form-group label-floating']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
          (null as any),0,i2.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
              i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i0.ɵpod({'has-error':0}),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          [[1,0],['inputRefId',1]],(null as any),8,'input',[['autofocus',''],['class',
              'form-control'],['name','inputRef'],['pattern','(\\d{4}\\.(\\d{2}\\.){2}\\d{2}$)|(\\d{4}\\.\\d{2}\\.\\d{4})$']],
          [[1,'pattern',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'blur'],[(null as any),'input'],
              [(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.InlineInputComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,19)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,19).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,19)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,19)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('input' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,22).ngOnChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_5:any = ((<any>(_co.model = $event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>_co.emmitModify()) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(540672,(null as any),0,i3.PatternValidator,([] as any[]),
          {pattern:[0,'pattern']},(null as any)),i0.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.PatternValidator]),i0.ɵdid(16384,(null as any),0,i5.TrimValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any,
          p1_0:any) => {
        return [p0_0,p1_0];
      },[i3.DefaultValueAccessor,i5.TrimValueAccessor]),i0.ɵdid(671744,[[2,4]],0,i3.NgModel,
          [[2,i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i0.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'span',[['class','material-input']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_InlineInputComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),i0.ɵppd(1),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:i4.InlineInputComponent = _v.component;
        const currVal_0:boolean = !_co.isEditing;
        _ck(_v,4,0,currVal_0);
        const currVal_9:any = 'form-group label-floating';
        const currVal_10:any = _ck(_v,16,0,!_co.modelRef.valid);
        _ck(_v,15,0,currVal_9,currVal_10);
        const currVal_19:any = '(\\d{4}\\.(\\d{2}\\.){2}\\d{2}$)|(\\d{4}\\.\\d{2}\\.\\d{4})$';
        _ck(_v,20,0,currVal_19);
        const currVal_20:any = 'inputRef';
        const currVal_21:any = _co.model;
        _ck(_v,24,0,currVal_20,currVal_21);
        const currVal_22:any = (i0.ɵunv(_v,31,0,_ck(_v,32,0,i0.ɵnov(_v,0),_co.modelRef.errors)) == 'pattern');
        _ck(_v,31,0,currVal_22);
      },(_ck,_v) => {
        var _co:i4.InlineInputComponent = _v.component;
        const currVal_1:boolean = !_co.isEditing;
        _ck(_v,6,0,currVal_1);
        const currVal_2:any = i0.ɵnov(_v,12).ngClassUntouched;
        const currVal_3:any = i0.ɵnov(_v,12).ngClassTouched;
        const currVal_4:any = i0.ɵnov(_v,12).ngClassPristine;
        const currVal_5:any = i0.ɵnov(_v,12).ngClassDirty;
        const currVal_6:any = i0.ɵnov(_v,12).ngClassValid;
        const currVal_7:any = i0.ɵnov(_v,12).ngClassInvalid;
        const currVal_8:any = i0.ɵnov(_v,12).ngClassPending;
        _ck(_v,8,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
        const currVal_11:any = (i0.ɵnov(_v,20).pattern? i0.ɵnov(_v,20).pattern: (null as any));
        const currVal_12:any = i0.ɵnov(_v,26).ngClassUntouched;
        const currVal_13:any = i0.ɵnov(_v,26).ngClassTouched;
        const currVal_14:any = i0.ɵnov(_v,26).ngClassPristine;
        const currVal_15:any = i0.ɵnov(_v,26).ngClassDirty;
        const currVal_16:any = i0.ɵnov(_v,26).ngClassValid;
        const currVal_17:any = i0.ɵnov(_v,26).ngClassInvalid;
        const currVal_18:any = i0.ɵnov(_v,26).ngClassPending;
        _ck(_v,18,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
            currVal_17,currVal_18);
      });
}
export function View_InlineInputComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'inline-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_InlineInputComponent_0,
      RenderType_InlineInputComponent)),i0.ɵdid(49152,(null as any),0,i4.InlineInputComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const InlineInputComponentNgFactory:i0.ComponentFactory<i4.InlineInputComponent> = i0.ɵccf('inline-input',
    i4.InlineInputComponent,View_InlineInputComponent_Host_0,{model:'model',name:'name'},
    {changeEvent:'changeEvent'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2lubGluZS1pbnB1dC9pbmxpbmUtaW5wdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2NvbW1vbi9pbmxpbmUtaW5wdXQvaW5saW5lLWlucHV0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2NvbW1vbi9pbmxpbmUtaW5wdXQvaW5saW5lLWlucHV0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2lubGluZS1pbnB1dC9pbmxpbmUtaW5wdXQuY29tcG9uZW50LnRzLklubGluZUlucHV0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiAqbmdJZj1cIiFpc0VkaXRpbmdcIiAoY2xpY2spPVwib3BlbigpXCI+IHt7IG1vZGVsfX0gPHNwYW4gY2xhc3M9XCJtYXRlcmlhbC1pY29uc1wiPm1vZGVfZWRpdDwvc3Bhbj4gPC9kaXY+IDxkaXYgW2hpZGRlbl09XCIhaXNFZGl0aW5nXCI+IDxmb3JtICNpbnB1dEZvcm09XCJuZ0Zvcm1cIiBub3ZhbGlkYXRlPiA8ZGl2IGNsYXNzPVwiZm9ybS1ncm91cCBsYWJlbC1mbG9hdGluZ1wiIFtuZ0NsYXNzXT1cIntcclxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICdoYXMtZXJyb3InOiAoIW1vZGVsUmVmLnZhbGlkKVxyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgfVwiPiA8aW5wdXQgI2lucHV0UmVmSWQgWyhuZ01vZGVsKV09XCJtb2RlbFwiIChibHVyKT1cImVtbWl0TW9kaWZ5KClcIiBhdXRvZm9jdXMgY2xhc3M9XCJmb3JtLWNvbnRyb2xcIiBuYW1lPVwiaW5wdXRSZWZcIiBwYXR0ZXJuPVwiKFxcZHs0fVxcLihcXGR7Mn1cXC4pezJ9XFxkezJ9JCl8KFxcZHs0fVxcLlxcZHsyfVxcLlxcZHs0fSkkXCI+IDxzcGFuIGNsYXNzPVwibWF0ZXJpYWwtaW5wdXRcIj48L3NwYW4+IDxkaXYgKm5nSWY9XCIobW9kZWxSZWYuZXJyb3JzIHwgZmlyc3RLZXkpID09ICdwYXR0ZXJuJ1wiPkhTIGNvZGUgc2hvdWxkIGJlOiBYWFhYLlhYLlhYLlhYIG9yIFhYWFguWFguWFhYWDwvZGl2PiA8L2Rpdj4gPC9mb3JtPiA8L2Rpdj4iLCI8aW5saW5lLWlucHV0PjwvaW5saW5lLWlucHV0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO1FBQUE7UUFBQTtRQUF3QjtVQUFBO1VBQUE7UUFBQTtRQUF4QjtNQUFBLGdDQUF5QywwQ0FBWTthQUFBO1VBQUE7TUFBNkIsOENBQWdCO1VBQUE7O0lBQXpEO0lBQUE7Ozs7b0JBRW1OO01BQUEsd0VBQXVEO2FBQUE7Ozs7O3dDQUZuVDtVQUFBLHFEQUFBO1VBQUE7TUFBeUcsc0NBQUM7VUFBQTtVQUFBLGdCQUEyQixzQ0FBQztVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBLG9DQUFBO1VBQUEsMEVBQUE7VUFBQSxvRUFBQTtVQUFBO1VBQUEsZUFBcUMsc0NBQUM7VUFBQTtVQUFBLGlFQUFBO1VBQUE7eUJBQUE7YUFBdUMsa0JBRXhLLHNDQUFDO1VBQUE7Y0FBQTtVQUFBO2NBQUE7a0JBQUE7VUFBQTtjQUFBO1VBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFtQjtjQUFBO2NBQUE7WUFBQTtZQUFvQjtjQUFBO2NBQUE7WUFBQTtZQUF2QztVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLDhDQUFBO1VBQUE7WUFBQTtVQUFBLGdDQUFBO1VBQUE7VUFBQSxzQkFBQTtrQkFBQTtRQUFBO01BQUEseURBQUE7VUFBQTtVQUFBLHFFQUFBO1VBQUEsOERBQUE7VUFBQSxpRUFBMEs7aUJBQUEsdUJBQUM7VUFBQTtVQUFBLDhCQUFvQyxzQ0FBQztpQkFBQTthQUFBO1VBQUEsK0JBQUssSUFBd0c7TUFBTyxzQ0FBUTs7O1FBRm5YO1FBQUwsV0FBSyxTQUFMO1FBQWlMO1FBQWtDO1FBQXZDLFlBQUssVUFBa0MsVUFBdkM7UUFFbkI7UUFBN0csWUFBNkcsVUFBN0c7UUFBNkY7UUFBMUU7UUFBbkIsWUFBNkYsV0FBMUUsVUFBbkI7UUFBcU47UUFBTCxZQUFLLFVBQUw7OztRQUY3STtRQUFMLFdBQUssU0FBTDtRQUE0QjtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFdBQUEscUVBQUE7UUFFMUY7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUEsV0FBQTtZQUFBLHFCQUFBOzs7O29CQ0Y1QztNQUFBO3FDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/common/inline-input/inline-input.component.ngfactory.ts